import { Component } from '@angular/core';
@Component({
  selector: 'app-testimonial',
  templateUrl: './testimonial.component.html',
  styleUrls: ['./testimonial.component.scss']
})
export class TestimonialComponent {
  slides = [
    {img: "http://placehold.it/350x150/000000"},
    {img: "http://placehold.it/350x150/111111"},
    {img: "http://placehold.it/350x150/333333"},
    {img: "http://placehold.it/350x150/666666"}
  ];
  slideConfig = {
    "dots": true,
    "slidesToShow": 1, 
    "slidesToScroll": 1,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  
  };
  
  addSlide() {
    this.slides.push({img: "http://placehold.it/350x150/777777"})
  }
  
  removeSlide() {
    this.slides.length = this.slides.length - 1;
  }
  
  slickInit(e:any) {
    //console.log('slick initialized');
  }
  
  breakpoint(e:any) {
    //console.log('breakpoint');
  }
  
  afterChange(e:any) {
    //console.log('afterChange');
  }
  
  beforeChange(e:any) {
    //console.log('beforeChange');
  }
}
